import React, { useEffect } from "react";
import "./OrderPlacedSuccessfullModal.css";
import { Button, Modal } from "react-bootstrap";
// import Successfull_Lottie from "../../../Animation/Successfull_Lottie/Successfull_Lottie";
// import Celebrate_Lottie from "../../../Animation/Celebrate_Lottie/Celebrate_Lottie";
import { Link, useNavigate } from "react-router-dom";
import Green_Btn from "../../common_btn/green_btn/Green_btn";
import Red_Outline_Btn from "../../common_btn/green_outline_btn/Green_Outline_Btn";
import Successfull_Lottie from "../../../Animation/Successfull_Lottie/Successfull_Lottie";

function OrderPlacedSuccessfullModal({
  baseLink,
  handleManualClose,
  ...props
}) {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    handleManualClose();
    navigate("/");
  };

  const handleContinueShopping = () => {
    handleManualClose();
    navigate("/product-listing-sub-category");
  };

  const handleViewDetails = () => {
    handleManualClose();
    navigate(baseLink);
  };

  return (
    <section className="OrderPlacedSuccessfullModal modal-holder">
      <Modal
        {...props}
        size="md"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="OrderPlacedSuccessfullModal modal-holder"
      >
        <Modal.Body>
          <div className="success_main_div">
            <div className="celebrate_lottie_holder"></div>
            <div className="success_loottie_holder">
              <Successfull_Lottie />
            </div>

            <div className="success_content_holder">
              <div className="text_holder">
                <p className="heading">Order Placed Successfully</p>
                <p className="sub_text">
                  Order placed successfully your product will be <br />{" "}
                  delivered soon.
                </p>
              </div>
            </div>

            <div className="text-center btn_holder">
              <div className="home_btn">
                <Red_Outline_Btn
                  btn_name="Go to Homeaa"
                  onClick={handleHomeClick}
                />
              </div>
              {/* <div className="continue_btn">
                <Green_Btn
                  btn_name="Continue Shopping"
                  onClick={handleContinueShopping}
                />
              </div> */}
            </div>

            {/* <div className="track_order_div">
              <div className="left_side_div">
                <div className="text_holder">
                  <div className="title">
                    <p>Track Your Order</p>
                  </div>
                  <div className="footer_text">
                    <p>Rider will be assigned soon</p>
                  </div>
                </div>
              </div>

              <div className="right_side">
                <div className="text-center btn_holder">
                  <Green_Btn
                    btn_name="View Details"
                    onClick={handleViewDetails}
                  />
                </div>
              </div>
            </div> */}
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
}

export default OrderPlacedSuccessfullModal;

// export default OrderPlacedSuccessfullModal;
